import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';
import { modelOf } from '../../../prop-types';
import RouteService from '../../../services/RouteService';
import AccountStore from '../../../store/AccountStore';
import Paths from '../../../types/Paths';
import HelperNavigation from '../../common/HelperNavigation';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import MyAccountInfoForm from '../MyAccountInfoForm';

const MyAccountInfo = ({ accountStore, intl, routeService }) => {
  const title = accountStore.isBalanceBuyer
    ? globalTranslations.balanceUserAccountInfo
    : globalTranslations.myAccountInfo;

  const getBreadcrumbsPath = () => {
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: accountStore.isBalanceBuyer
          ? Paths.MyAccountBalanceUser
          : Paths.MyAccount,
      },
      {
        text: accountStore.isBalanceBuyer
          ? intl.formatMessage(globalTranslations.balanceUserAccountInfo)
          : intl.formatMessage(globalTranslations.myAccountInfo),
        url: accountStore.isBalanceBuyer
          ? Paths.MyAccountBalanceUserAccountInfo
          : Paths.MyAccountInfo,
      },
    ]);
  };

  return (
    <>
      <HelperNavigation breadcrumbsPath={getBreadcrumbsPath()} />
      <div className="MyAccountInfo">
        <SEOTitle
          title={
            accountStore.isBalanceBuyer
              ? globalTranslations.balanceUserAccountInfo
              : globalTranslations.myAccountInfo
          }
        />
        <PageTitle>
          <FormattedMessage {...title} />
        </PageTitle>
        <MyAccountInfoForm />
      </div>
    </>
  );
};

MyAccountInfo.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
};

export default injectIntl(
  inject('accountStore', 'routeService')(observer(MyAccountInfo))
);
